const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/live/timeline/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { getItemsTreeSetQueryOptions } from 'src/lib/queries/common/useGetItemsDataSetQuery';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { itemPanelSearchSchema } from '@/lib/zod-schemas/itemPanelSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/live/timeline/')({
  loader: async ({
    params: {
      loopId
    },
    context: {
      queryClient
    }
  }) => {
    const filter = {
      loopId: {
        value: Number(loopId),
        operator: 'eq' as const
      }
    };
    await queryClient.ensureQueryData(getItemsTreeSetQueryOptions({
      filter
    }));
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema),
  pendingComponent: FullSizeSpinner
});